import React from "react"
import { useForm, NestedValue } from 'react-hook-form';
import "@/styles/component/input.scss"

type Props = {
  name: string,
  type: string,
  placeholder?: string,
  register?: any
  errors?: any
}
const Input: React.FC<Props> = ({ name, type, placeholder = "入力してください", register, errors }) => (
  <input name={name}
    className={`input ${errors[name] ? "error" : ""}`}
    type={type}
    placeholder={placeholder}
    ref={register({ required: true })}
  ></input>
)

export default Input
